import { Reducer } from "redux";

import { UserVerifyMfaInfoActionDispatchTypes } from "../constants/User";
import { UserMfaInfoResponse } from "../models/api/User";
import { UserVerifyMfaInfoActionTypes } from "../models/dispatchTypes/User";

export const initialState: UserMfaInfoResponse = {
  loading: false,
  response: {
    userId: "",
    email: "",
    otp: 0,
    status: "",
  },
  error: null,
};

const UserVerifyMfaInfoReducer: Reducer<
  UserMfaInfoResponse,
  UserVerifyMfaInfoActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UserVerifyMfaInfoActionDispatchTypes.USER_VERIFY_MFA_CODE_LOADING: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case UserVerifyMfaInfoActionDispatchTypes.USER_VERIFY_MFA_CODE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: null,
      };
    }
    case UserVerifyMfaInfoActionDispatchTypes.USER_VERIFY_MFA_CODE_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    case UserVerifyMfaInfoActionDispatchTypes.USER_VERIFY_MFA_CODE_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UserVerifyMfaInfoReducer;
